// ✅ Action Types
import * as actionTypes from "../ActionTypes";

// ✅ Fetch Ministries
export const fetchMinistriesRequest = (payload, callback) => ({
  type: actionTypes.FETCH_MINISTRIES_REQUEST,
  payload,
  callback,
});

export const fetchMinistriesSuccess = (data) => ({
  type: actionTypes.FETCH_MINISTRIES_SUCCESS,
  payload: data,
});

export const fetchMinistriesFailure = (error) => ({
  type: actionTypes.FETCH_MINISTRIES_FAILURE,
  payload: error,
});

// ✅ Save Ministry
export const saveMinistryRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_MINISTRY_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveMinistrySuccess = (data) => ({
  type: actionTypes.SAVE_MINISTRY_SUCCESS,
  payload: data,
});

export const saveMinistryFailure = (error) => ({
  type: actionTypes.SAVE_MINISTRY_FAILURE,
  payload: error,
});

// ✅ Delete Ministry
export const deleteMinistryRequest = (payload, callback) => ({
  type: actionTypes.DELETE_MINISTRY_REQUEST,
  payload,
  callback,
});

export const deleteMinistrySuccess = (data) => ({
  type: actionTypes.DELETE_MINISTRY_SUCCESS,
  payload: data,
});

export const deleteMinistryFailure = (error) => ({
  type: actionTypes.DELETE_MINISTRY_FAILURE,
  payload: error,
});

// ✅ Update Ministry
export const updateMinistryRequest = (payload, callback) => ({
  type: actionTypes.UPDATE_MINISTRY_REQUEST,
  payload,
  callback,
});

export const updateMinistrySuccess = (data) => ({
  type: actionTypes.UPDATE_MINISTRY_SUCCESS,
  payload: data,
});

export const updateMinistryFailure = (error) => ({
  type: actionTypes.UPDATE_MINISTRY_FAILURE,
  payload: error,
});

// ✅ Fetch Ministry by ID
export const fetchMinistryByIdRequest = (_id, callback) => ({
  type: actionTypes.FETCH_MINISTRY_BY_ID_REQUEST,
  payload: { _id },
  callback,
});

export const fetchMinistryByIdSuccess = (ministry) => ({
  type: actionTypes.FETCH_MINISTRY_BY_ID_SUCCESS,
  payload: ministry,
});

export const fetchMinistryByIdFailure = (error) => ({
  type: actionTypes.FETCH_MINISTRY_BY_ID_FAILURE,
  payload: error,
});
